<template>

    <div class="lesson_page" v-if="bigCat5Lesson != null">
        <img :src="geneNetworkPicture(bigCat5Lesson.background.backgroundPicture)" class="big_cat_blur_backgroud"/>
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="title">第{{bigCat5Lesson.lessonNo}}课</div>
            <div class="clear"></div>
        </div>
        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>
        <div class="lesson">
            <div class="lesson_picture">
                <img :src="geneNetworkPicture(bigCat5Lesson.picture)" alt=""/>
            </div>
            <div class="english_title">{{bigCat5Lesson.englishName}}</div>

            <!-- 音频播放 -->
            <div class="lesson_audio">
                <div class="info">
                    <div class="title">这节课讲什么</div>
                    <div class="mp3_progress">
                        <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                    </div>
                    <div class="time">
                        <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                        <div class="time_end">{{bigCat5Lesson.guideAudioDurationDisplayString}}</div>
                        <div class="clear"></div>
                    </div>
                </div>
                <div class="play" @click="changeStart">
                    <audio v-bind:src="$qiNiuDomainBase + bigCat5Lesson.guideAudio" id="musicMp3"
                           controls=""></audio>
                    <img v-if="!isPlay" src="@/assets/player_play1.png" height="40" width="40"/>
                    <img v-else src="@/assets/player_pause1.png" height="40" width="40"/>
                </div>
                <div class="clear"></div>
            </div>

            <!-- 学单词、听音频 -->
            <div class="child_row">
                <div class="left_image" @click="learningWord()">
                    <img src="@/Images/learning_word.png" alt="" />
                </div>
                <div class="h_split split_color"></div>
                <div class="right_image" @click="followRead()">
                    <img src="@/Images/follow_read.png" alt="" />
                </div>
                <div class="clear"></div>
            </div>
            <div style="height: 40px;">
                <div class="v_right_split split_color"></div>
            </div>
            <!-- 理思路、跟着读 -->
            <div class="child_row">
                <div class="left_image" @click="lookExplain()">
                    <img src="@/Images/look_explain.png" alt="" />
                </div>
                <div class="h_split split_color"></div>
                <div class="right_image" @click="clarifyThinking()">
                    <img src="@/Images/clarify_thinking.png" alt="" />
                </div>
                <div class="clear"></div>
            </div>
            <div style="height: 40px;">
                <div class="v_left_split split_color"></div>
            </div>
            <!-- 看讲解、打个卡 -->
            <div class="child_row" style="margin-bottom: 50px;">
                <div class="left_image" @click="punchCard">
                    <img v-if="bigCat5Lesson.finish === 0" src="@/Images/punch_card.png" alt="" />
                    <img v-else src="@/Images/learn_finish.png" alt="" />
                </div>
                <div class="clear"></div>
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                courseId: 0,
                lessonId: 0,
                bigCat5Lesson: null,
                progress: 0,
                isPlay: false,
                currentTime: 0,
                mTimer: null
            }
        },
        methods: {
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay;
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    if (musicMp3 != null) {
                        musicMp3.pause();
                    }
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    that.mTimer = setInterval(() => {
                        const numbers = musicMp3.currentTime / musicMp3.duration;
                        let perNumber = (numbers * 100).toFixed(2);
                        if (perNumber >= 100) {
                            that.isPlay = false;
                            that.progress = 0;
                            that.currentTime = 0;
                            clearInterval(that.mTimer);
                            that.mTimer = null;
                        } else {
                            that.progress = perNumber;
                            that.currentTime = musicMp3.currentTime;
                        }
                    }, 50);
                }
            },
            callChangeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }

                that.changeProgress()
            },
            learningWord: function () {
                this.$router.push({name: "BLearnWord", query: {lessonId: this.lessonId}});
            },
            listenAudio: function () {
                this.$router.push({name: "BWordlist", query: {lessonId: this.lessonId}});
            },
            clarifyThinking: function () {
                this.$router.push({name: "BStructure", query: {lessonId: this.lessonId}});
            },
            followRead: function () {
                this.$router.push({name: "BFollow", query: {lessonId: this.lessonId}});
            },
            lookExplain: function () {
                this.$router.push({name: "BStrategy", query: {lessonId: this.lessonId}});
            },
            punchCard: function () {
                let that = this;
                let finishFlag = that.bigCat5Lesson.finish === 0 ? 1 : 0;
                let url = "bigCat/setFinish/" + that.lessonId + "/" + finishFlag;

                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        that.bigCat5Lesson.finish = finishFlag;
                    } else {
                        window.console.log("操作失败")
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        },
        mounted: function () {
            this.callChangeProgress();
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat/getLessonHomeInfo/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.bigCat5Lesson = response.data;
                that.lessonId = vlessonId;

                if (!that.isWeixinBrowser()) {
                    that.$nextTick(() => {
                        $(window).scroll(function () {
                            var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                            if (scrollTop > 44) {
                                $("#navigation_title").removeClass("navigation");
                                $("#navigation_title").addClass("navigation_white");
                            } else {
                                $("#navigation_title").removeClass("navigation_white");
                                $("#navigation_title").addClass("navigation");
                            }
                        });
                    });
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>

    .lesson_page {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .lesson {
        position: relative;
        width: 100%;
        z-index: 997;
        display: inline-block;
        text-align: -webkit-center;
    }

    .lesson_picture {
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }

    .lesson_picture img {
        width: 150px;
        height: 150px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .english_title {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-top: 5px;
        margin-bottom: 10px;
        color: white;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }

    .lesson_audio {
        position: relative;
        background-color: rgba(0, 0, 0, 0.7);
        margin: 20px 20px 40px 20px;
        padding: 15px;
        border: 2px solid #e69e30;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        max-width: 500px;
    }

    .lesson_audio .info {
        margin-right: 50px;
    }

    .lesson_audio .play {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }

    .lesson_audio .info .title {
        font-size: 15px;
        font-weight: bold;
        color: white;
        text-align: left;
    }

    .lesson_audio .info .mp3_progress {
        width: 100%;
        height: 4px;
        background-color: #999999;
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: left;
    }

    .lesson_audio .info .now_progress {
        position: relative;
        @extend % transition;
        height: 4px;
        background-color: #64c846;
    }

    .lesson_audio .time {
        font-size: 12px;
        color: white;
    }

    .lesson_audio .time .time_start {
        float: left;
    }

    .lesson_audio .time .time_end {
        float: right;
    }

    audio {
        display: none;
    }

    .lesson .child_row {
        width: 100%;
        height: 100px;
        margin: 0;
    }

    .lesson .child_row .left_image {
        height: 100px;
        float: left;
        margin-left: calc((100% - 200px)/4);
    }

    .lesson .child_row .right_image {
        height: 100px;
        float: right;
        margin-right: calc((100% - 200px)/4);
    }

    .lesson .child_row .left_image img, .lesson .child_row .right_image img {
        width: 100px;
        height: 100px;
    }

    .lesson .child_row .h_split {
        float: left;
        width: calc((100% - 200px)/2);
        height: 10px;
        margin-top: 45px;
    }

    .lesson .v_right_split {
        float: right;
        width: 10px;
        height: 100%;
        margin-right: calc((100% - 200px)/4 + 45px);
    }

    .lesson .v_left_split {
        float: left;
        width: 10px;
        height: 100%;
        margin-left: calc((100% - 200px)/4 + 45px);
    }

    .split_color {
        background-color: rgba(192,156,48, 0.7);
    }

</style>